import { render, staticRenderFns } from "./UserViewUserAction.vue?vue&type=template&id=09223760&"
import script from "./UserViewUserAction.vue?vue&type=script&lang=js&"
export * from "./UserViewUserAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports